<textarea class="mw-100 w-100" maxlength="300" [ngClass]="isCorrectAnswer===true?'sql-option-box-success':isCorrectAnswer===false?'sql-option-box-failure':''" [id]="id" [name]="name" rows="4" [(ngModel)]="value" (change)="getValue()">
    {{value}}
</textarea>